import { useDeployment } from "@/lib/hooks/useDeployment";
import { useMessageStore } from "@/state/stores";
import { useMemo } from "react";
import { useShallow } from "zustand/shallow";
import { isBootsmanResult } from "../MessageParts";

export function useLatestDeploymentUrl(projectId?: string): string | null {
  const messages = useMessageStore(useShallow((state) => state.messages));

  // Find the most recent deployment ID from tool-call messages
  const latestDeploymentId = useMemo(() => {
    for (let i = messages.length - 1; i >= 0; i--) {
      const message = messages[i];
      if (!message.parts) {
        continue;
      }

      for (const part of message.parts) {
        if (
          part.type === "tool-call" &&
          part.toolName === "deployment" &&
          part.status === "complete" &&
          isBootsmanResult(part.result) &&
          part.result.success &&
          typeof part.result.data === "object" &&
          part.result.data &&
          "deploymentId" in part.result.data &&
          typeof part.result.data.deploymentId === "string"
        ) {
          return part.result.data.deploymentId;
        }
      }
    }
    return null;
  }, [messages]);

  // Fetch deployment details using the API
  const { data: deploymentData } = useDeployment(
    projectId,
    latestDeploymentId || undefined,
  );

  // Return the deployment URL if available
  return deploymentData?.data.deployment.url || null;
}
